<template>
  <div class="service-dropdown" tabindex="0" @focusout="onFocusOut">
    <button
      class="service-pill"
      :class="{ readonly }"
      :style="pillStyle"
      type="button"
      @mousedown.stop="!readonly && toggle()"
    >
      {{ selectedLabel }}

      <i
        v-if="!readonly && icon"
        :class="[icon, 'service-pill-icon', { rotate: open }]"
      />
    </button>

    <div v-if="open && !readonly" class="service-menu">
      <div
        v-for="option in options"
        :key="option[valueKey]"
        class="service-item"
        @click="select(option)"
      >
        {{ option[labelKey] }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActiveDropdown',

  props: {
    value: {
      required: false,
    },

    options: {
      type: Array,
      required: true,
      default: () => [],
    },

    valueKey: {
      type: String,
      default: 'value',
    },
    labelKey: {
      type: String,
      default: 'label',
    },

    backgroundColor: {
      type: String,
      default: '#9fb5ad',
    },

    placeholder: {
      type: String,
      default: 'Seleccione',
    },

    readonly: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      open: false,
    };
  },
  computed: {
    selectedLabel() {
      const selected = this.options.find(
        (o) => o[this.valueKey] === this.value
      );
      return selected ? selected[this.labelKey] : this.placeholder;
    },

    pillStyle() {
      return {
        backgroundColor: this.backgroundColor,
        cursor: this.readonly ? 'not-allowed' : 'pointer',
        opacity: this.readonly ? 0.75 : 1,
      };
    },
  },
  watch: {
    readonly(newVal) {
      if (newVal) this.open = false;
    },
    value() {
      this.open = false;
    },
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },
    onFocusOut(event) {
      if (!this.$el.contains(event.relatedTarget)) {
        this.open = false;
      }
    },
    select(option) {
      if (this.readonly) return;
      this.$emit('input', option[this.valueKey]);
      this.open = false;
    },
  },
};
</script>

<style>
.service-dropdown {
  position: relative;
  display: inline-block;
}

.service-pill {
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 11px 35px;
  font-size: 17px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  --icon-bg: #3f5b60;
  --icon-fg: #9faea7;
}

.service-pill-icon {
  margin-left: 12px;
  border-radius: 999px;
  padding: 4px;
  background: var(--icon-bg);
  color: var(--icon-fg);
  transition: transform 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.service-pill-icon.rotate {
  transform: rotate(180deg);
}

.service-pill.readonly {
  pointer-events: none;
}
.service-menu {
  position: absolute;
  top: 110%;
  left: 0px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  min-width: 190px;
  z-index: 1000;
}

.service-item {
  padding: 11px 35px;
  cursor: pointer;
  font-size: 17px;
}

.service-item:hover {
  background-color: #f2f2f2;
}
.service-pill.readonly {
  pointer-events: none;
}
</style>
